import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, Counter } from "@/components/site/motion";
import Seo from "@/components/site/Seo";
import { TEAM_PHOTO, IMAGES } from "@/data/content";

export default function Squadra() {
    const { t } = useLang();
    const s = t.team;
    const navigate = useNavigate();

    return (
        <div data-testid="team-page">
            <Seo title={t.seo.team.t} description={t.seo.team.d} image={TEAM_PHOTO} path="/squadra" />

            <section className="relative pt-40 pb-20 bg-cb-dark cb-grid overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <img src={IMAGES.hero} alt="" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-cb-darker/80" />
                </div>
                <div className="relative max-w-7xl mx-auto px-6">
                    <Reveal className="text-cb-accent text-xs uppercase tracking-[0.3em] mb-4">{s.chapter}</Reveal>
                    <Reveal as="h1" delay={0.3} className="font-display text-5xl md:text-7xl font-bold tracking-tighter text-white">{s.title}</Reveal>
                    <Reveal delay={0.6} className="mt-6 max-w-2xl text-slate-300 text-lg">{s.sub}</Reveal>
                </div>
            </section>

            <section className="bg-white">
                <Reveal className="relative">
                    <div className="max-w-7xl mx-auto px-6 -mt-10 md:-mt-16 relative z-10">
                        <div className="overflow-hidden shadow-2xl shadow-black/20">
                            <img src={TEAM_PHOTO} alt={s.photoCaption} className="w-full object-cover" />
                        </div>
                        <p className="mt-4 text-sm text-slate-400 text-center italic">{s.photoCaption}</p>
                    </div>
                </Reveal>
            </section>

            <section className="py-20 md:py-28 bg-white">
                <div className="max-w-4xl mx-auto px-6">
                    <Reveal className="text-slate-600 text-lg md:text-xl leading-relaxed">{s.p1}</Reveal>
                    <Reveal delay={0.4} className="mt-6 text-slate-600 text-lg md:text-xl leading-relaxed">{s.p2}</Reveal>

                    <div className="mt-14 grid grid-cols-3 gap-8 border-t border-slate-200 pt-12">
                        {s.stats.map((st, i) => (
                            <Reveal key={i} delay={i * 0.4}>
                                <div className="font-display text-4xl md:text-5xl font-bold text-cb-dark">
                                    <Counter value={st.value} suffix={st.suffix} />
                                </div>
                                <div className="mt-1 text-sm text-slate-500">{st.label}</div>
                                <div className="mt-3 h-px w-12 bg-cb-accent" />
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <section className="relative py-24 md:py-32 bg-cb-dark cb-grid text-white overflow-hidden">
                <div className="max-w-3xl mx-auto px-6 text-center relative">
                    <Reveal as="h2" className="font-display text-3xl md:text-5xl font-bold tracking-tighter">{t.finalCta.title}</Reveal>
                    <Reveal delay={0.5}>
                        <button data-testid="team-cta" onClick={() => navigate("/preventivo")}
                            className="cb-glow mt-8 inline-flex items-center gap-2 bg-cb-accent hover:bg-cb-accentHover text-white px-8 py-4 font-medium transition-colors">
                            {t.finalCta.btn} <ArrowRight size={18} />
                        </button>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
